export default "__VITE_ASSET__abe73f60__"